import { render, staticRenderFns } from "./simpleDropdown.vue?vue&type=template&id=a2aba0e2&"
import script from "./simpleDropdown.vue?vue&type=script&lang=js&"
export * from "./simpleDropdown.vue?vue&type=script&lang=js&"
import style0 from "./simpleDropdown.vue?vue&type=style&index=0&id=a2aba0e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports